export default __webpack_public_path__ + "static/media/CIA-ALTERNATIVE-ENERGY-2024.c4a93ac0.pdf";